export class PasswordCredential {
  constructor(password: string) {
    this.credentials.password.value = password;
  }
  credentials: PasswordCredential_Credential = new PasswordCredential_Credential();
}

export class PasswordCredential_Credential{
  password: PasswordCredential_Credential_Password = new PasswordCredential_Credential_Password();
}

export class PasswordCredential_Credential_Password {
  value: string;
}
